<script setup lang="ts">
import {ref} from "vue";
import ParameterEditorNumber from "./ParameterEditorNumber.vue";
import ParameterEditorText from "./ParameterEditorText.vue";

const props = defineProps<{
  parameterName: string
  parameterType: string
  parameters: Record<string, string>
}>();

if (!props.parameters[props.parameterName]) {
  props.parameters[props.parameterName] = '';
}

const value = ref(props.parameters[props.parameterName]);

let editor: any;
if (props.parameterType === 'number')
{
  editor = ParameterEditorNumber;
} else if (props.parameterType === 'text') {
  editor = ParameterEditorText;
}

function capitalize(input: string) {
  input = input.replace(/((?<![\.\s])[A-Z])/g, ' $1');
  input = input.replace(/(\.\w)/g, (match) => '.' + match.charAt(1).toUpperCase());
  input = input.charAt(0).toUpperCase() + input.slice(1);
  return input;
}

</script>

<template>
  
  <div class="p">
    <label>{{capitalize(parameterName)}}</label>
    <component :is="editor" v-model="props.parameters[props.parameterName]" :parameter-type="parameterType" />
  </div>
  
</template>

<style scoped>



</style>